import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PcmpAccountsBatchPrintPage } from '@/features/pcmp/pages/PcmpAccountsBatchPrintPage';

export const Route = createFileRoute('/_print/pcmp/accounts/batches/$batchNo/print')({
  parseParams: ({ batchNo }) => {
    const parsedNo = Number(batchNo);
    if (!Number.isInteger(parsedNo) || parsedNo <= 0) throw notFound();
    return { batchNo: parsedNo };
  },
  component: () => (
    <ErrorBoundary moduleName="PCMP Accounts Batch Report">
      <PcmpAccountsBatchPrintPage />
    </ErrorBoundary>
  ),
});
